// extracted by mini-css-extract-plugin
export default {"logo":"logo-module--logo--3d4fa","logoDesktop":"logo-module--logoDesktop--7fb79","logoTouch":"logo-module--logoTouch--967e7"};